export enum Features {
    default = 'default',
    collaborator = 'collaborator',
    unlimitedForms = 'unlimitedForms',
    customDomain = 'customDomain',
    workspace = 'workspace'
}
